import React from 'react';
import SuperAdminPanel from './SuperAdminPanel';

export default function ControlPanel({
  userRole,
  analytics,
  users,
  fetchUsers,
  token,
  userProfile
}) {
  if (userRole === 'admin') {
    return (
      <SuperAdminPanel
        analytics={analytics}
        users={users}
        fetchUsers={fetchUsers}
        token={token}
        userProfile={userProfile}
      />
    );
  }
  return <div style={{padding:32}}>Acesso restrito ao administrador.</div>;
}
